import {
  trigger,
  sequence,
  state,
  stagger,
  animate,
  transition,
  style,
  query,
  animateChild,
} from "@angular/animations";

export const fadeOut = trigger("fadeOut", [
  state(
    "void",
    style({ opacity: 0, transform: "translateX(-550px)", "box-shadow": "none" })
  ),
  transition("void => *", sequence([animate("1s ease")])),
  transition("* => void", [animate("0.5s ease")]),
]);

export const LoginFade = trigger("LoginFade", [
  state(
    "void",
    style({
      opacity: 0,
      transform: "translateY(+1000px)",
      "box-shadow": "none",
    })
  ),
  transition("void => *", sequence([animate("1.5s ease")])),
  transition("* => void", [animate("0.5s ease")]),
]);

export const LogoFade = trigger("LogoFade", [
  state(
    "void",
    style({ opacity: 0, transform: "scaleY(1.5)", "box-shadow": "none" })
  ),
  transition("void => *", sequence([animate("1.5s ease")])),
  transition("* => void", [animate("0.5s ease")]),
]);
